const form = require('./form.ejs');

export default { form };
